<template>
    <b-container fluid id="tables">
        <b-row class="d-flex justify-content-center text-center">
            <b-col lg="2" xs="2" md="2" xl="2" class="my-3">
                <input class="form-control ShifokrSverka" type="date" v-model="datas.date1" />
            </b-col>
            <b-col lg="2" xs="2" md="2" xl="2" class="my-3">
                <input class="form-control ShifokrSverka" type="date" v-model="datas.date2" />
            </b-col>
            <b-col lg="2" xs="2" md="2" xl="2" class="my-3">
                <v-select :options="bolim" v-model="datas.category_id" :reduce="option => option.id" label="name"
                    :placeholder="$t('Бўлим танланг...')" @input="filterBolim" />
            </b-col>
            <b-col lg="2" xs="2" md="2" xl="2" class="my-3">
                <v-select :options="xona" v-model="datas.room_id" :reduce="option => option.id" label="name"
                    :placeholder="$t('Хона танланг...')" @input="filterXona" />
            </b-col>
            <b-col lg="2" xs="2" md="2" xl="2" class="my-3">
                <v-select :options="koyka" v-model="datas.palata_id" :reduce="option => option.id" label="name"
                    :placeholder="$t('Койка танланг...')" />
            </b-col>
            <b-col lg="2" xs="2" md="2" xl="2" class="my-3">
                <button type="button" class="btn text-white" style="background: #195FB0; width: 100px; font-size: 14px"
                    @click="Send()">
                    <img src="../../../public/Vector.png" alt="" style="margin-right: 5px" />
                    {{ $t("Кўриш") }}
                </button>
                <button class="btn text-white" style="background: #195FB0; width: 100px; margin-left: 10px; font-size: 14px" @click="downloadExl">
                    Юклаш
                </button>
                <b-button class="navbarBtnDanger ml-3" variant="danger" @click="cancel()">
                    <b-icon icon="x-circle-fill"></b-icon>
                </b-button>
            </b-col>
        </b-row>
        <div class="tablesD">
            <table class="table  table-bordered table-sm table-striped" id="my-table">
                <tr class="bg-dark text-white" style="position: sticky; top: 1px; z-index: 1; background: #fff;">
                    <th style="background: yellow; width: 14%">{{ $t("Жой номи") }}</th>
                    <th style="background: yellow; width: 14%">{{ $t("Жой нархи") }}</th>
                    <th style="background: greenyellow; width: 14%">{{ $t("Банд кунлар сони") }}</th>
                    <th style="background: greenyellow; width: 14%">{{ $t("Банд кунлар сумма(тўлаган)") }}</th>
                    <th style="background: greenyellow; width: 14%">{{ $t("Банд кунлар сумма(тўламаган)") }}</th>
                    <th style="background: #fa555a; width: 14%">{{ $t("Бўш кунлар сони") }}</th>
                    <th style="background: #fa555a; width: 14%">{{ $t("Бўш кунлар сумма") }}</th>
                </tr>
                <tr v-for="item in results">
                    <td>{{ item.statistik.xona_name +'-'+ item.statistik.palata_name }}</td>
                    <td>{{ item.statistik.price | numFormat }}</td>
                    <td>{{ item.statistik.band_kunlar_soni }}</td>
                    <td>{{ item.statistik.tolangan_summa | numFormat }}</td>
                    <td>{{ item.statistik.qarzdor_summa | numFormat }}</td>
                    <td>{{ item.bosh_kunlar_soni }}</td>
                    <td>{{ item.bosh_kunlar_summa | numFormat }}</td>
                </tr>
                <tr style="background: green; color: #fff;">
                    <td colspan="2">{{ $t("Жами") }}</td>
                    <!-- <td>{{ total.joy_narxi | numFormat }}</td> -->
                    <td>{{ total.band_kunlar_soni }}</td>
                    <td>{{ total.band_kunlar_summa_tolagan | numFormat }}</td>
                    <td>{{ total.band_kunlar_summa_tolamagan | numFormat }}</td>
                    <td>{{ total.bosh_kunlar_soni }}</td>
                    <td>{{ total.bosh_kunlar_summa | numFormat }}</td>
                </tr>
            </table>
        </div>
    </b-container>
</template>

<script>
import moment from "moment";
var XLSX = require("xlsx");
var FileSaver = require("file-saver");
import { required, minLength } from "vuelidate/lib/validators";
export default {
    data() {
        return {
            datas: {
                date1: new Date().toISOString().slice(0, 8) + "01",
                date2: new Date().toISOString().slice(0, 10),
                category_id: null,
                room_id: null,
                palata_id: null
            },
            results: [],
            bolim: [],
            xona: [],
            koyka: [],
            total: {
                joy_narxi: 0,
                band_kunlar_soni: 0,
                band_kunlar_summa_tolagan: 0,
                band_kunlar_summa_tolamagan: 0,
                bosh_kunlar_soni: 0,
                bosh_kunlar_summa: 0
            },
            localUser: JSON.parse(localStorage.getItem("user"))
        };
    },
    filters: {
        dateFormatDD: function (date) {
            if (date != null) {
                return moment(new Date(date * 1000)).format("DD.MM.YYYY HH:mm");
            } else {
                return "";
            }
        }
    },
    created() {
        let self = this;
        if (
            JSON.parse(localStorage.getItem("datas")) &&
            self.localUser.role != "Shifokor"
        ) {
            self.datas.date1 = JSON.parse(localStorage.getItem("datas")).date1;
            self.datas.date2 = JSON.parse(localStorage.getItem("datas")).date2;
            self.datas.doctor_id = JSON.parse(
                localStorage.getItem("datas")
            ).doctor_id;
            self.Send();
            localStorage.removeItem("datas");
        }
        if (self.localUser.role == "Shifokor") {
            self.datas.doctor_id = self.localUser.doctor.id;
            self.doctor = self.localUser.doctor.name;
        }
    },
    validations: {
        datas: {
            category_id: {
                required
            },
            room_id: {
                required
            },
            palata_id: {
                required
            }
        },
    },
    methods: {
        filterBolim(id) {
            let self = this;
            self.getXona(id);
        },
        filterXona(id) {
            let self = this;
            self.getKoyka(id);
        },
        Send() {
            let self = this;
            // self.$v.$touch();
            // if (self.$v.datas.$error == false) {
                var datas = {
                    datetime1: parseInt(
                        new Date(self.datas.date1)
                            .valueOf()
                            .toString()
                            .slice(0, 10)
                    ),
                    datetime2: parseInt(
                        new Date(self.datas.date2)
                            .valueOf()
                            .toString()
                            .slice(0, 10)
                    ) + 86399,
                    category_id: self.datas.category_id,
                    room_id: self.datas.room_id,
                    palata_id: self.datas.palata_id
                };
                axios({
                    method: "post",
                    url: "hisobot/palata_analitika",
                    data: datas
                }).then(function (res) {
                    self.total.band_kunlar_soni = 0;
                    self.total.band_kunlar_summa_tolagan = 0;
                    self.total.band_kunlar_summa_tolamagan = 0;
                    self.total.bosh_kunlar_soni = 0;
                    self.total.bosh_kunlar_summa = 0;
                    
                    self.results = res.data.data;
                    let model = res.data.data;
                    for (let i = 0; i < model.length; i++) {
                        self.total.joy_narxi += model[i].statistik.price;
                        self.total.band_kunlar_soni += model[i].statistik.band_kunlar_soni;
                        self.total.band_kunlar_summa_tolagan += model[i].statistik.tolangan_summa;
                        self.total.band_kunlar_summa_tolamagan += model[i].statistik.qarzdor_summa;
                        self.total.bosh_kunlar_soni += model[i].bosh_kunlar_soni;
                        self.total.bosh_kunlar_summa += model[i].bosh_kunlar_summa;                        
                    }
                });
            // } else {
            //     self.$bvToast.toast(this.$t("Маълумотлар тўлиқ киритилмаган!"), {
            //         title: this.$t("Огоҳлантириш"),
            //         variant: "warning",
            //         autoHideDelay: 2000,
            //         appendToast: true
            //     });
            // }
        },
        Router(item) {
            if (item.doc_type === "kirim" && this.datas.date1 <= this.datas.date2) {
                let route = this.$router.resolve({
                    path: "/arxivone/" + item.doc_id
                });
                window.open(route.href, "_blank");
            } else if (this.datas.date1 <= this.datas.date2) {
                let route = this.$router.resolve({
                    path: "oplataDoc/" + item.doc_id
                });
                window.open(route.href, "_blank");
            }
        },
        cancel() {
            window.close();
        },
        getBolim() {
            let self = this;
            axios({
                method: "get",
                url: "/palata_category/all"
            }).then(res => {
                if (!res.data.error) {
                    self.bolim = res.data.data;
                }
            });
        },
        getXona(id) {
            let self = this;
            axios({
                method: "get",
                url: "/xona_etaj/filter_category/" + id
            }).then(res => {
                if (!res.data.error) {
                    self.xona = res.data.data;
                }
            });
        },
        getKoyka(id) {
            let self = this;
            axios({
                method: "get",
                url: "/palata/filter_palata/" + id
            }).then(res => {
                if (!res.data.error) {
                    self.koyka = res.data.data;
                }
            });
        },
        downloadExl() {
            let wb = XLSX.utils.table_to_book(document.getElementById("my-table")),
                wopts = {
                    bookType: "xlsx",
                    bookSST: false,
                    type: "binary"
                };
            var wscols = [
                { width: 30 },
                { width: 30 },
                { width: 30 },
                { width: 30 },
                { width: 30 },
                { width: 30 },
                { width: 30 },
                { width: 30 },
                { width: 30 },
                { width: 30 },
                { width: 30 },
                { width: 10 },
                { width: 13 },
                { width: 13 },
                { width: 10 },
                { width: 13 },
                { width: 13 },
                { width: 13 },
                { width: 13 }
            ];
            wb.Sheets.Sheet1["!cols"] = wscols;
            let wbout = XLSX.write(wb, wopts);
            const currentDate = new Date();

            const day = currentDate
                .getDate()
                .toString()
                .padStart(2, "0");
            const month = (currentDate.getMonth() + 1).toString().padStart(2, "0"); // Adding 1 because months are zero-based
            const year = currentDate.getFullYear().toString();
            const hours = currentDate
                .getHours()
                .toString()
                .padStart(2, "0");
            const minutes = currentDate
                .getMinutes()
                .toString()
                .padStart(2, "0");
            const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}`;
            FileSaver.saveAs(
                new Blob([this.s2ab(wbout)], {
                    type: "application/octet-stream;charset=utf-8"
                }),
                formattedDate + "_Statsionar_Analitika.xlsx"
            );
        },
        s2ab(s) {
            const buf = new ArrayBuffer(s.length);
            const view = new Uint8Array(buf);
            for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
            return buf;
        }
    },
    mounted() {
        this.getBolim();
    }
};
</script>

<style scoped>
.table {
    margin: 0px 0px !important;
}

.tablesD {
  overflow-y: scroll;
  overflow-x: hidden;
  height: calc(100vh - 130px);
  width: 100%;
}
label,
td,
th,
tr {
    font-family: "Times New Roman", Times, serif;
    font-weight: bolder;
    text-transform: capitalize;
    font-size: 15px;
    height: 30px !important;
    text-align: center;
}

.ShifokrSverka {
    border-radius: 3px;
    background: #fff;
    border: 1px solid rgb(210, 210, 210);
}

.navbarBtnDanger {
    border: 1px solid #fff;
    /* box-shadow: 5px 8px 10px rgba(176, 25, 25, 0.3); */
    background: #e80a18;
    border-radius: 8px;
}

.reds {
    color: red;
}

#tables {
    height: 100vh !important;
    width: 99% !important;
}

th {
    color: #195fb0;
    background-color: #f4f7fb;
}
</style>